import React, {Component} from "react";
import {Route, Redirect} from 'react-router-dom';
import {ayncCheckLogin} from "../../utills/userUtils";
export default (WrappedComponent) => {
    return class extends Component {
        state={
            authorized:true
        }
        constructor(props) {
            super(props)
        }
        componentWillMount() {
            ayncCheckLogin().then(()=>{
                this.setState({
                    authorized: true
                })
            },()=>{
                this.setState({
                    authorized: false
                })
            })
        }
        render() {
            let { component: Component, ...rest} = this.props;
            return  this.state.authorized ?
                (<Route {...rest} render={(props) => ( <Component {...props} />
                )}/> ) : (<Redirect to='/login'/>)
        }
    }
}